import React from "react";
import { Card, Box, Grid, Skeleton, Stack } from "@mui/material";
import { colors, borderRadiusPx, customShadows } from "../../../../../theme";

export const AboutHeroSkeleton = () => (
  <Card
    sx={{
      p: { xs: 3, sm: 4.5 },
      borderRadius: borderRadiusPx.xl,
      backgroundColor: colors.dashboard.cardBg,
      border: `1px solid ${colors.dashboard.cardBorder}`,
      boxShadow: customShadows.cardFlat,
      mb: 4,
    }}
  >
    <Grid container spacing={4} alignItems="center">
      <Grid item xs={12} lg={7}>
        <Stack spacing={2}>
          <Skeleton variant="rounded" width={180} height={28} sx={{ borderRadius: borderRadiusPx.full }} />
          <Skeleton variant="text" width="90%" height={50} />
          <Skeleton variant="text" width="98%" height={24} />
          <Skeleton variant="text" width="85%" height={24} />
          <Stack direction="row" spacing={1.5} sx={{ pt: 1 }}>
            <Skeleton variant="rounded" width={160} height={42} sx={{ borderRadius: borderRadiusPx.xl }} />
            <Skeleton variant="rounded" width={140} height={42} sx={{ borderRadius: borderRadiusPx.xl }} />
          </Stack>
        </Stack>
      </Grid>
      <Grid item xs={12} lg={5}>
        <Grid container spacing={2}>
          {[1, 2, 3, 4].map((i) => (
            <Grid item xs={6} key={i}>
              <Box
                sx={{
                  p: 2.25,
                  borderRadius: borderRadiusPx.lg,
                  bgcolor: colors.slate[50],
                  border: `1px solid ${colors.slate[200]}`,
                }}
              >
                <Skeleton variant="text" width="60%" height={18} sx={{ mb: 1 }} />
                <Skeleton variant="text" width="80%" height={28} sx={{ mb: 0.5 }} />
                <Skeleton variant="text" width="50%" height={16} />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  </Card>
);

export const AboutPillarsSkeleton = () => (
  <Grid container spacing={3} sx={{ mb: 4 }}>
    {[1, 2, 3, 4, 5, 6].map((i) => (
      <Grid item xs={12} sm={6} lg={4} key={i}>
        <Card
          sx={{
            p: 3,
            borderRadius: borderRadiusPx.xl,
            backgroundColor: colors.dashboard.cardBg,
            border: `1px solid ${colors.dashboard.cardBorder}`,
            boxShadow: customShadows.cardFlat,
          }}
        >
          <Skeleton variant="rounded" width={44} height={44} sx={{ mb: 2, borderRadius: borderRadiusPx.lg }} />
          <Skeleton variant="text" width="75%" height={26} sx={{ mb: 1 }} />
          <Skeleton variant="text" width="100%" height={18} />
          <Skeleton variant="text" width="90%" height={18} />
        </Card>
      </Grid>
    ))}
  </Grid>
);

export default AboutHeroSkeleton;
